import script from "./ProjectManageUploadSettingGeoblockSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageUploadSettingGeoblockSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageUploadSettingGeoblockSection.vue?vue&type=style&index=0&id=554625ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554625ec"]])

export default __exports__